import { MediaMatcher } from "@angular/cdk/layout";
import { InovaAppInjector } from "./app-injector.";

export class MobileQuery {
  mobileQuery: MediaQueryList | undefined;
  constructor(){
    const injector = InovaAppInjector.getInjector();
    if (injector) {
      const media: MediaMatcher= injector.get(MediaMatcher);
      this.mobileQuery = media.matchMedia('(max-width: 600px)');
    }
  }
}
